import Synchronization from './Synchronization';

export default Synchronization;
